import React, { useEffect, useState, createElement } from 'react';
import { CountdownTimer } from './components/CountdownTimer';
import { PurchasePopup } from './components/PurchasePopup';
import { ExitIntentPopup } from './components/ExitIntentPopup';
import { VideoIntroPopup } from './components/VideoIntroPopup';
import { ProductPreviewCarousel } from './components/ProductPreviewCarousel';
import { UrgencyModule } from './components/UrgencyModule';
import { CheckIcon, XIcon, ShieldIcon, DownloadIcon, UsersIcon, ClockIcon, StarIcon, ZapIcon, AwardIcon, ChevronDownIcon, BriefcaseIcon } from 'lucide-react';
const PURCHASE_URL = 'https://gf0puq-6f.myshopify.com/cart/52842799333600:1?channel=buy_button';
const MESES_ES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
function getTodayInSpanish() {
  const today = new Date();
  const day = today.getDate();
  const month = MESES_ES[today.getMonth()];
  return `${day} de ${month}`;
}
export function App() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [todayLabel] = useState(getTodayInSpanish());
  // Meta Pixel injection
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1486404246405720');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1486404246405720&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
  }, []);
  const scrollToOffer = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const compraSection = document.getElementById('compra');
    if (compraSection) {
      compraSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="w-full min-h-screen bg-white" data-id="element-0" data-mp="86cm572q1bkp">
      <PurchasePopup data-id="element-1" data-mp="3gkv1ltuzrtec" />
      <ExitIntentPopup data-id="element-2" data-mp="3gm64zskiyz4x" />

      {/* Top Urgency Bar — Premium Deep Navy & Gold */}
      <div className="w-full bg-gradient-to-r from-slate-950 via-slate-900 to-slate-950 text-white py-3 px-4 text-center sticky top-0 z-50 border-b border-yellow-500/50 shadow-[0_4px_25px_rgba(0,0,0,0.5)] relative overflow-hidden" data-id="element-3" data-mp="3bn2z65wq0ovw">
        <div className="absolute inset-0 bg-[linear-gradient(90deg,transparent_0%,rgba(234,179,8,0.05)_50%,transparent_100%)]" data-id="element-4" data-mp="3liwgs3par8kj"></div>
        <div className="max-w-7xl mx-auto relative z-10" data-id="element-5" data-mp="2svtovuf4lw39">
          <div className="flex flex-wrap items-center justify-center gap-2 text-xs md:text-sm" data-id="element-6" data-mp="2svagp5fa2m2f">
            <span className="flex items-center gap-2" data-id="element-7" data-mp="18c6og57cpuff">
              <span className="text-yellow-500 animate-pulse" data-id="element-8" data-mp="1d47z5movfd3c">⚖️</span>
              <span className="font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 uppercase tracking-widest drop-shadow-sm" data-id="element-9" data-mp="1d6aw6qofy6hk">
                Oferta exclusiva solo por hoy {todayLabel}
              </span>{' '}
              <span className="text-slate-400 font-medium hidden sm:inline" data-id="element-10" data-mp="1r5kcrrgk72m2">
                — Expira en:
              </span>{' '}
              <CountdownTimer data-id="element-11" data-mp="1w19d3x0eknjf" />
            </span>
          </div>
          <div className="text-[11px] md:text-xs text-slate-400 mt-1 text-center font-medium tracking-wide" data-id="element-12" data-mp="1i2swnecqnio3">
            Últimos <span className="text-red-400 font-bold" data-id="element-13" data-mp="1m3cu6j184oar">4 cupos</span> al
            precio promocional + 6 bonus
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="w-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-800 via-slate-900 to-black py-12 px-4 relative overflow-hidden" data-id="element-14" data-mp="aqsif8zurla4">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-72 bg-amber-400/15 rounded-full blur-3xl pointer-events-none" data-id="element-15" data-mp="m5x4ywtp4suo"></div>
        <div className="absolute bottom-0 left-1/4 w-72 h-72 bg-yellow-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-16" data-mp="h7lwapf50oe1"></div>
        <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)',
        backgroundSize: '48px 48px'
      }} data-id="element-17" data-mp="19vztx42bdip2"></div>
        <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-18" data-mp="zzoew6bcaeqx">
          <div className="flex justify-center mb-6" data-id="element-19" data-mp="vvyuzu5m0lc8">
            <div className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-yellow-500/30 bg-slate-900/60 backdrop-blur-md shadow-[0_0_20px_rgba(234,179,8,0.15)] hover:shadow-[0_0_30px_rgba(234,179,8,0.25)] transition-shadow duration-300" data-id="element-20" data-mp="3kokmzid33b1h">
              <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-21" data-mp="1w2ltx0fhidbd"></div>
              <span className="text-xs md:text-sm font-bold uppercase tracking-widest" data-id="element-22" data-mp="206a1hj4498wm">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 to-yellow-500" data-id="element-23" data-mp="253k2lw0vb90a">
                  Para NOVELES ABOGADOS
                </span>
                <span className="text-slate-300 font-medium" data-id="element-24" data-mp="2etv4ze4wla52">
                  {' '}
                  <span className="mx-1 text-slate-600" data-id="element-25" data-mp="2jt82cstehzlw">|</span> Válido para
                  toda la Argentina 🇦🇷
                </span>
              </span>
            </div>
          </div>

          <h1 className="mx-auto mb-6 max-w-5xl text-center text-[clamp(2.25rem,7vw,4.5rem)] font-black uppercase leading-[0.98] tracking-tight text-white" data-id="element-26" data-mp="2sv7kxpk2dbqy">
            De la teoría a la{' '}
            <span className="text-yellow-400 drop-shadow-[0_0_15px_rgba(234,179,8,0.3)]" data-id="element-27" data-mp="ygeo5n7g2exf">
              práctica:
            </span>{' '}
            tu primer año como Novel Abogado{' '}
            <span className="text-green-400 drop-shadow-[0_0_15px_rgba(34,197,94,0.3)]" data-id="element-28" data-mp="1wshby74ci42q">
              resuelto en 5 minutos
            </span>
          </h1>

          <p className="text-lg md:text-xl text-slate-300 mb-8 max-w-3xl mx-auto text-center font-light leading-relaxed" data-id="element-29" data-mp="2attp6as4frkx">
            Nuestro pack reúne los principales recursos prácticos para
            estudiantes y noveles abogados Argentinos. Todo resuelto en un sólo
            lugar para que{' '}
            <span className="font-semibold text-white" data-id="element-30" data-mp="2fr3bvio4lp52">ahorres tiempo</span>,
            consultes cada vez que necesites y{' '}
            <span className="font-semibold text-white" data-id="element-31" data-mp="2ph4zyaghb7jz">
              evites errores de amateur
            </span>
            .
          </p>

          <div className="block max-w-2xl mx-auto mb-5 relative" data-id="element-32" data-mp="33hzaayn37ila">
            <div className="absolute inset-0 bg-yellow-500/20 rounded-2xl blur-2xl" data-id="element-33" data-mp="2yi37v3u1fz7u"></div>
            <img src="https://cdn.magicpatterns.com/uploads/iJJdpCyfxh5BQG3hJzFyXz/PRESENTACION_ERICA_Y_JIME_-_VIERNES_12_DE_JUNIO.png" alt="Mega Pack de Procuración Jurídica 2026" className="w-full h-auto relative z-10 drop-shadow-2xl" data-id="element-34" data-mp="3i3muukx7cp4o" />
          </div>

          <a href="#compra" onClick={scrollToOffer} className="inline-flex items-center justify-center mb-8 rounded-xl border-2 border-green-400 bg-green-600 px-8 py-4 text-base font-black uppercase tracking-wide text-white shadow-[0_0_28px_rgba(34,197,94,0.38)] transition-[transform,box-shadow,background-color] duration-200 ease-out hover:-translate-y-0.5 hover:bg-green-500 hover:shadow-[0_0_38px_rgba(34,197,94,0.52)] md:px-12 md:text-xl" data-id="element-35" data-mp="384xckr1e92nw">
            QUIERO ACCEDER AL MEGAPACK
          </a>

          <h2 className="text-xl md:text-2xl text-yellow-400 mb-4 max-w-3xl mx-auto font-bold leading-relaxed text-center tracking-wide" data-id="element-36" data-mp="2ge9h9vmeiri5">
            TUS PRIMEROS PASOS EN LA PRÁCTICA PROFESIONAL Y PROCURACIÓN JURÍDICA
          </h2>

          <div className="bg-slate-900/80 backdrop-blur-xl rounded-3xl shadow-[0_0_40px_rgba(234,179,8,0.15)] p-8 md:p-10 max-w-3xl mx-auto mt-4 mb-8 border border-yellow-500/20 relative overflow-hidden" data-id="element-37" data-mp="30uc9e66c0ene">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-600 via-yellow-400 to-yellow-600" data-id="element-38" data-mp="2qvwf5uc0cp9o"></div>
            <h3 className="text-2xl md:text-3xl font-black text-white mb-8 uppercase text-center tracking-wide" data-id="element-39" data-mp="2m07e1mkcb0b9">
              GUÍA PASO A PASO DE PROCURACIÓN JURÍDICA 2026{' '}
              <span className="text-yellow-400" data-id="element-40" data-mp="2d4865zx22gwx">+ 6 BONUS</span>
            </h3>
            <div className="grid md:grid-cols-2 gap-5 text-left" data-id="element-41" data-mp="287rg306apsh7">
              {['Escrito + estructura + orden (sin caos mental)', 'Paso a paso real (lo que en la facu no te dicen)', 'Subida al PJN sin trabarte (fueros principales)', 'Honorarios con criterio (sin regalar tu laburo)', 'Primera entrevista con clientes sin quedarte en blanco', 'Comunidad +714 colegas para destrabarte rápido'].map((text, i) => <div key={i} className="flex items-start gap-3 bg-slate-800/50 p-4 rounded-xl border border-slate-700/50 hover:border-yellow-500/30 transition-colors" data-id="element-42" data-mp="9nusjd08u1q1" data-mpi={i}>
                  <div className="bg-green-500/20 rounded-full p-1 flex-shrink-0 mt-0.5" data-id="element-43" data-mp="ipu9y6f677ti">
                    <CheckIcon className="h-4 w-4 text-green-400" data-id="element-44" data-mp="nonmnwmmuusm" />
                  </div>
                  <span className="text-slate-300 text-sm md:text-base font-medium" data-id="element-45" data-mp="nmb8zvnwr6ld">
                    {text}
                  </span>
                </div>)}
            </div>
          </div>

          <p className="text-sm font-bold text-yellow-400 mb-4 text-center drop-shadow-[0_0_10px_rgba(234,179,8,0.4)]" data-id="element-46" data-mp="3r3b7q5vx64wg">
            ⭐ Garantía de satisfacción 14 días ⭐
          </p>
        </div>
      </section>

      {/* Problem Section */}
      <section className="w-full bg-[#f8fafc] py-12 px-4 relative overflow-hidden" data-id="element-47" data-mp="33glcbne2t8kt">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-300 to-transparent" data-id="element-48" data-mp="38emqpv0k4jpy"></div>
        <div className="absolute top-1/2 left-0 w-96 h-96 bg-red-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-49" data-mp="2f63mvygwdugl"></div>
        <div className="absolute top-1/2 right-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-50" data-mp="2k4nas4f1xgbl"></div>

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-51" data-mp="2p3gn3tilr1a6">
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-10 text-center uppercase leading-tight tracking-tight" data-id="element-52" data-mp="2u33145698lk1">
            Si sos novel abogado, dejame hacerte una pregunta honesta:
          </h2>

          <div className="bg-white rounded-3xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.1)] p-8 md:p-12 mb-10 border border-slate-100 relative overflow-hidden" data-id="element-53" data-mp="21g04xjp1wmwy">
            <div className="absolute top-0 left-0 w-full h-1 bg-red-500" data-id="element-54" data-mp="2b5s12icsto3j"></div>
            <p className="text-2xl md:text-4xl font-black text-red-600 mb-8 text-center tracking-tight" data-id="element-55" data-mp="1dqe4yu0uu3nw">
              ¿Te pasa que el miedo a equivocarte te hace tardar el triple?
            </p>
            <p className="text-lg md:text-xl text-slate-600 mb-8 text-center font-medium" data-id="element-56" data-mp="3vz8qg7b1hgfj">
              Porque una cosa es saber Derecho… y otra muy distinta es ejercer
              en el mundo real, donde:
            </p>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-57" data-mp="3my148nlss61t">
              {['Un detalle te puede hacer perder días', 'Un formato mal armado te lo rebotan', 'Un cliente te pregunta "¿y ahora qué sigue?" (y no quiere teoría 😅)', 'Y el PJN… bueno, el PJN no perdona distracciones'].map((text, i) => <div key={i} className="flex items-start gap-4 bg-red-50/50 p-5 rounded-2xl border border-red-100" data-id="element-58" data-mp="38a680x8kzjjz" data-mpi={i}>
                  <div className="bg-red-100 rounded-full p-1.5 flex-shrink-0 mt-0.5" data-id="element-59" data-mp="347jgyyjqi2nu">
                    <XIcon className="h-5 w-5 text-red-500" data-id="element-60" data-mp="2z9rmpxvma4gh" />
                  </div>
                  <span className="text-slate-700 font-medium leading-relaxed" data-id="element-61" data-mp="2u9vji0uquh1z">
                    {text}
                  </span>
                </div>)}
            </div>
            <div className="mt-10 text-center" data-id="element-62" data-mp="2pd53fdixvlgk">
              <p className="inline-block bg-red-50 text-red-700 px-6 py-3 rounded-full text-lg font-bold border border-red-100" data-id="element-63" data-mp="2fn6ks18bg7wn">
                No es que no sepas. Es que nadie te dio el paso a paso real.
              </p>
            </div>
          </div>

          <div className="bg-slate-900 text-white rounded-3xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.3)] p-8 md:p-12 mb-8 border border-slate-800 relative overflow-hidden" data-id="element-64" data-mp="26p4dj3xzoj0x">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-600 via-yellow-400 to-yellow-600" data-id="element-65" data-mp="2yeh8k9iqw4kb"></div>
            <div className="absolute -right-20 -top-20 w-64 h-64 bg-yellow-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-66" data-mp="33ev6gyqmty4m"></div>
            <h3 className="text-2xl md:text-4xl font-black mb-8 text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 to-yellow-500 uppercase text-center tracking-tight" data-id="element-67" data-mp="2tmpjy4j5g8wt">
              El problema que nadie dice en voz alta (pero todos viven)
            </h3>
            <p className="text-lg md:text-xl mb-8 text-slate-300 text-center font-light" data-id="element-68" data-mp="3m5cu4owly3j4">
              En tu primer año, es normal que pase esto:
            </p>
            <div className="grid md:grid-cols-2 gap-5" data-id="element-69" data-mp="15ox2gbby9ajo">
              {['Tenés conocimiento… pero no tenés sistema', 'Te cuesta saber "qué va primero" y "qué no se toca"', 'Perdés horas buscando modelos (y ninguno coincide)', 'Dudás con requisitos, adjuntos, formatos, presentación', 'Te frena el miedo al error "de principiante"', 'Te agarran casos y sentís que estás corriendo atrás de todo'].map((text, i) => <div key={i} className="flex items-start gap-4 bg-slate-800/50 p-4 rounded-xl border border-slate-700/50" data-id="element-70" data-mp="ms5aldicdn40" data-mpi={i}>
                  <div className="bg-yellow-500/20 rounded-full p-1 flex-shrink-0 mt-0.5" data-id="element-71" data-mp="11ls1webfjixo">
                    <CheckIcon className="h-4 w-4 text-yellow-400" data-id="element-72" data-mp="wquv7e1mhlny" />
                  </div>
                  <span className="text-slate-200 font-medium" data-id="element-73" data-mp="2d16yhgzq88s9">{text}</span>
                </div>)}
            </div>
            <div className="mt-10 bg-red-500/10 border border-red-500/20 rounded-2xl p-6 text-center" data-id="element-74" data-mp="2861ggt9g3e9g">
              <p className="text-xl md:text-2xl font-bold text-red-400" data-id="element-75" data-mp="hp64we5yakzs">
                Y lo peor: laburás mucho, avanzás poco, y vivís con la sensación
                de estar siempre atrás.
              </p>
            </div>
          </div>

          {/* → scroll a oferta */}
        </div>
      </section>

      {/* Solution Section */}
      <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black text-white py-14 px-4 border-t border-slate-800 relative overflow-hidden" data-id="element-76" data-mp="10mh2lubxp6d4">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-full bg-yellow-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-77" data-mp="1acjyc2afwyf5"></div>
        <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,1) 1px, transparent 1px)',
        backgroundSize: '64px 64px'
      }} data-id="element-78" data-mp="1jc6uo9obbe1c"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-79" data-mp="1ycubsij8tigr">
          <div className="inline-flex items-center gap-2 bg-yellow-500/10 border border-yellow-500/30 text-yellow-400 font-bold text-sm md:text-base px-6 py-2 rounded-full mb-8 uppercase tracking-widest shadow-[0_0_20px_rgba(234,179,8,0.15)]" data-id="element-80" data-mp="1tesploqit312">
            <span className="animate-pulse" data-id="element-81" data-mp="2h5ey1h4fspbl">⚖️</span> LA SOLUCIÓN
          </div>
          <h2 className="mx-auto mb-8 max-w-5xl text-center text-4xl font-black uppercase leading-tight tracking-tight md:text-6xl" data-id="element-82" data-mp="2h7j342e2nudg">
            GUÍA PASO A PASO DE{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 drop-shadow-[0_0_15px_rgba(234,179,8,0.2)]" data-id="element-83" data-mp="27e266pin1z5k">
              PROCURACIÓN JURÍDICA 2026
            </span>{' '}
            <span className="whitespace-nowrap text-3xl text-white md:text-4xl" data-id="element-84" data-mp="2v5hd6vld14n5">+ 6 BONUS</span>
          </h2>
          <p className="text-xl md:text-2xl mb-14 text-slate-300 text-center font-light leading-relaxed max-w-3xl mx-auto" data-id="element-85" data-mp="t8764kt1iozl">
            Un sistema práctico para que tus primeros pasos sean claros,
            ordenados y{' '}
            <span className="font-semibold text-white" data-id="element-86" data-mp="jh2qrjzgd248">profesionales</span>,
            válido para toda Argentina 🇦🇷
          </p>

          <div className="bg-slate-800/40 backdrop-blur-xl rounded-3xl p-8 md:p-12 mb-14 border border-slate-700/50 shadow-2xl relative overflow-hidden" data-id="element-87" data-mp="ofe2k09b5mp3">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-slate-700 via-slate-400 to-slate-700" data-id="element-88" data-mp="fgsmcbrb6jrh"></div>
            <h3 className="text-2xl md:text-3xl font-black mb-10 text-white uppercase text-center tracking-wide" data-id="element-89" data-mp="kjlj5rrrycy">
              Cómo se usa <span className="text-yellow-400" data-id="element-90" data-mp="5kfjan9vitk2">(en 3 pasos)</span>
            </h3>
            <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-91" data-mp="1uy2h4a28p6vm">
              {[{
              step: '1',
              text: 'Abrís la guía'
            }, {
              step: '2',
              text: 'Elegís el trámite / situación'
            }, {
              step: '3',
              text: 'Aplicás el paso a paso + material listo'
            }].map((item, i) => <div key={i} className="bg-slate-900/80 rounded-2xl p-8 text-center border border-slate-700/50 hover:border-yellow-500/30 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(0,0,0,0.5)] group" data-id="element-92" data-mp="3u4hkjb2frgi7" data-mpi={i}>
                  <div className="w-16 h-16 mx-auto bg-slate-800 rounded-full flex items-center justify-center mb-6 border border-slate-600 group-hover:border-yellow-500/50 group-hover:bg-yellow-500/10 transition-colors" data-id="element-93" data-mp="6xozpxeay2nd">
                    <span className="text-3xl font-black text-yellow-400" data-id="element-94" data-mp="gvbs9moixspt">
                      {item.step}
                    </span>
                  </div>
                  <p className="text-lg md:text-xl font-medium text-slate-200" data-id="element-95" data-mp="2ipuaktprde1r">
                    {item.text}
                  </p>
                </div>)}
            </div>
            <div className="mt-10 inline-block bg-yellow-500/10 border border-yellow-500/20 rounded-full px-8 py-3" data-id="element-96" data-mp="1rxkdvjozn87r">
              <p className="text-lg md:text-xl font-bold text-yellow-400 text-center" data-id="element-97" data-mp="1wuu24w0n5du0">
                Sin vueltas. Sin improvisar. Sin perder tiempo.
              </p>
            </div>
          </div>

          {/* → scroll a oferta */}
          <a href="#compra" onClick={scrollToOffer} className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-xl md:text-2xl px-12 py-6 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.3)] hover:shadow-[0_0_50px_rgba(34,197,94,0.5)] transform hover:scale-105 transition-all duration-300 animate-pulse-slow uppercase text-center border-2 border-green-400" data-id="element-98" data-mp="26nrppgkhpszh">
            QUIERO MI MEGAPACK
          </a>
        </div>
      </section>

      {/* What's Included Section */}
      <section className="w-full bg-gradient-to-b from-white via-slate-50 to-white py-10 px-4 relative overflow-hidden" data-id="element-99" data-mp="2udlxvktv6tde">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-64 bg-amber-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-100" data-mp="nmr0832a6m0o"></div>
        <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-101" data-mp="iq0lpk64jyhd">
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-6 uppercase text-center" data-id="element-102" data-mp="dvwcsvdatgdn">
            ¿Qué incluye exactamente?
          </h2>

          <div className="bg-slate-50 rounded-xl shadow-xl p-8 mb-8 border border-slate-200" data-id="element-103" data-mp="3yrr0wnd7mxd">
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-104" data-mp="3w2u19pyw1cg1">
              <StarIcon className="h-8 w-8 text-yellow-500 fill-yellow-500" data-id="element-105" data-mp="3w4wzuye3wdwd" />
              <h3 className="text-2xl md:text-3xl font-black text-slate-900 uppercase text-center" data-id="element-106" data-mp="3r497a8a8bp01">
                Producto principal
              </h3>
            </div>
            <div className="block mb-4" data-id="element-107" data-mp="1pcmeq2aovm1g">
              <img src="https://cdn.magicpatterns.com/uploads/gN2kG2xBBMWAFKYTTxmgEw/Guia_de_procuracion_juridica_Paso_a_paso.png" alt="Guía Paso a Paso de Procuración Jurídica 2026" className="w-full max-w-xl mx-auto h-auto rounded-lg shadow-lg" style={{
              aspectRatio: '1/1',
              objectFit: 'cover'
            }} data-id="element-108" data-mp="1pbkzdlmn4ddx" />
            </div>
            <h4 className="text-2xl font-bold text-slate-900 mb-3 text-center" data-id="element-109" data-mp="22grbq63a63i1">
              GUÍA PASO A PASO DE PROCURACIÓN JURÍDICA 2026
            </h4>
            <p className="text-lg text-slate-700 mb-3 text-center" data-id="element-110" data-mp="1xglqb7nltd8e">
              Pensada para noveles abogados que necesitan:
            </p>
            <ul className="space-y-3 text-slate-800 max-w-md mx-auto text-left" data-id="element-111" data-mp="1ohi4vx0yslqq">
              <li className="flex items-start gap-3" data-id="element-112" data-mp="1ji59gnw126cj">
                <CheckIcon className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-113" data-mp="1jix3vvdw1y18" />
                <span data-id="element-114" data-mp="1el530bv9n1kw">Orden mental (qué va primero, qué va después)</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-115" data-mp="3dvepkyj2wq3r">
                <CheckIcon className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-116" data-mp="38xuxovtgketc" />
                <span data-id="element-117" data-mp="38vsbkmvff5tw">Ejecución (no "información para leer algún día")</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-118" data-mp="3hcsx9m5qs9ei">
                <CheckIcon className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-119" data-mp="3lf5s3fiyamwi" />
                <span data-id="element-120" data-mp="3q6nr3y1eydeu">Una ruta clara para actuar con criterio y rapidez</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="w-full bg-gradient-to-b from-slate-50 via-slate-100 to-slate-50 pt-6 pb-10 px-4 relative overflow-hidden" data-id="element-121" data-mp="2yg18wybcf43l">
        <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-122" data-mp="32i4itiid60mr"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-yellow-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-123" data-mp="37f4qfxuv3bfz"></div>
        <div className="max-w-6xl mx-auto relative z-10" data-id="element-124" data-mp="mq79517bfxg7">
          <div className="bg-slate-900 rounded-xl p-6 mb-6 text-center border-t-4 border-yellow-500 shadow-[0_0_30px_rgba(234,179,8,0.16)]" data-id="element-125" data-mp="mpp3xf2oe8w5">
            <p className="text-sm md:text-base font-black uppercase tracking-[0.18em] text-red-400 mb-3" data-id="element-126" data-mp="215zolgt1yoj">
              Solo disponibles gratis por hoy
            </p>
            <h2 className="text-3xl md:text-5xl font-black text-yellow-400 uppercase text-center" data-id="element-127" data-mp="3t77gzbrd5oim">
              🎁 6 Bonus para potenciar tus resultados
            </h2>
            <p className="text-lg md:text-xl font-medium text-slate-200 mt-3 max-w-3xl mx-auto text-center" data-id="element-128" data-mp="71almr0hflm5">
              Recursos prácticos para mejorar tu experiencia, avanzar con más
              seguridad y sacarle el máximo provecho a tu MegaPack.
            </p>
            <div className="inline-flex items-center mt-5 rounded-full bg-red-500/15 border border-red-400/40 px-5 py-2" data-id="element-129" data-mp="3p5lynaw28i11">
              <span className="text-sm md:text-base font-black uppercase tracking-wide text-red-300" data-id="element-130" data-mp="3ke47feju9vt9">
                Gratis únicamente durante la oferta de hoy
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-131" data-mp="2rpoucxk9pnkk">
            <div className="block" data-id="element-132" data-mp="178pbuvwx8p5r">
              <div className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] border border-slate-200 overflow-hidden" data-id="element-133" data-mp="177nt059nyydh">
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-134" data-mp="1c18sy2uti2fb">
                  <img src="https://cdn.magicpatterns.com/uploads/dmZen66tPjYDX1sotCwXwK/Bonus_1.png" alt="Bonus 1" className="w-full h-full object-cover" data-id="element-135" data-mp="x8f2xnhx63we" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-136" data-mp="1pzqepv15x4ul">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-137" data-mp="1uwysljfa2mq1">
                    ✅ BONUS 1: Introducción – Escritos Judiciales Paso a Paso
                  </h3>
                  <p className="text-slate-700" data-id="element-138" data-mp="1l1x6yxk7o2s7">
                    Para dejar de armar escritos "a ojo" y entender: estructura,
                    lógica, qué va / qué no va, errores típicos de principiante
                    que te hacen perder tiempo.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-139" data-mp="ptefb5yrfjx8">
                    <span className="text-slate-400 line-through font-bold" data-id="element-140" data-mp="l023xxj3d9mf">
                      ARS 14.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-141" data-mp="fzxli1ymi4tk">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="block" data-id="element-142" data-mp="13sw8ryn03lcx">
              <div className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] border border-slate-200 overflow-hidden" data-id="element-143" data-mp="13prz4lqrnxev">
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-144" data-mp="urfzju7x9paa">
                  <img src="https://cdn.magicpatterns.com/uploads/vo6eXqb7q1Dns49oikMBZ8/Bonus_2.png" alt="Bonus 2" className="w-full h-full object-cover" data-id="element-145" data-mp="3jiz81vkeletn" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-146" data-mp="1uzcz9xg1b3jr">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-147" data-mp="1ux094x04hmvm">
                    ✅ BONUS 2: Guía Completa: Cómo Subir un Escrito al Portal
                    del PJN
                  </h3>
                  <p className="text-slate-700" data-id="element-148" data-mp="28rjcbanw4uez">
                    Para que el PJN no te coma la cabeza: paso a paso claro,
                    checklist previo a subir, cómo evitar trabas comunes,
                    presentación sin pánico.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-149" data-mp="2mqisdtxc80zj">
                    <span className="text-slate-400 line-through font-bold" data-id="element-150" data-mp="2mog5hirhenz1">
                      ARS 18.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-151" data-mp="sd1dswewuegn">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="block" data-id="element-152" data-mp="1vn5hjsdxxmt7">
              <div className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] border border-slate-200 overflow-hidden" data-id="element-153" data-mp="1vo71yngujlnl">
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-154" data-mp="29o84068ukz4n">
                  <img src="https://cdn.magicpatterns.com/uploads/xw4C8Bo7tFvuqQ8dBb9i9d/Bonus_3.png" alt="Bonus 3" className="w-full h-full object-cover" data-id="element-155" data-mp="24q6kjk7iexsn" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-156" data-mp="2elhy3z76lyyt">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-157" data-mp="2sdo813jqr9pt">
                    ✅ BONUS 3: Guía Práctica de Honorarios Profesionales
                    (Argentina)
                  </h3>
                  <p className="text-slate-700" data-id="element-158" data-mp="3299fhh7kx26y">
                    Para que no te pase el clásico: "¿Cuánto cobro?" → silencio
                    incómodo. Acá tenés criterio para presupuestar y cobrar sin
                    regalarte.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-159" data-mp="3lwvq5bofb95c">
                    <span className="text-slate-400 line-through font-bold" data-id="element-160" data-mp="36z3dqse6b0vd">
                      ARS 16.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-161" data-mp="3c1aurwdv174k">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-162" data-mp="2obgj3i5a1olw">
            <div className="block" data-id="element-163" data-mp="2t86ys4d66i6s">
              <div className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] border border-slate-200 overflow-hidden" data-id="element-164" data-mp="2t988a4ejewme">
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-165" data-mp="2fbbcha7wqu8s">
                  <img src="https://cdn.magicpatterns.com/uploads/r3X8EagC5xJm8b4HKhFQbT/Bonus_4.png" alt="Bonus 4" className="w-full h-full object-cover" data-id="element-166" data-mp="2zq1rm0clcrxp" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-167" data-mp="2uovs9jofe6f7">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-168" data-mp="2pqkif8y4rvwz">
                    ✅ BONUS 4: Guía Práctica: Tu Primera Entrevista con
                    Clientes
                  </h3>
                  <p className="text-slate-700" data-id="element-169" data-mp="2c0qwozhx9rrh">
                    Para que la entrevista no sea un caos: qué preguntar, cómo
                    ordenar el caso, cómo transmitir seguridad sin humo, cómo
                    salir con próximos pasos claros.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-170" data-mp="220gipco2cgb9">
                    <span className="text-slate-400 line-through font-bold" data-id="element-171" data-mp="1x2ewiivcc0vk">
                      ARS 12.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-172" data-mp="8jua3ldftyip">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="block" data-id="element-173" data-mp="hi629rtyd4d9">
              <div className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] border border-slate-200 overflow-hidden" data-id="element-174" data-mp="mjvaz0tpd5y6">
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-175" data-mp="3l2a9vcqdjmlc">
                  <img src="https://cdn.magicpatterns.com/uploads/aP8hCyUAzELr5zghVNRPmQ/Bonus_5.png" alt="Bonus 5" className="w-full h-full object-cover" data-id="element-176" data-mp="3q0buw37d1vzg" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-177" data-mp="3liyb53l1dxu">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-178" data-mp="32ardhoquv6sa">
                    ✅ BONUS 5: Pasos Previos al Ejercicio Profesional
                  </h3>
                  <p className="text-slate-700" data-id="element-179" data-mp="2h0otstbcgcsr">
                    Checklist para empezar bien: orden básico, preparación
                    práctica, prevención de errores por apuro.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-180" data-mp="27y75m9c4pa34">
                    <span className="text-slate-400 line-through font-bold" data-id="element-181" data-mp="2bzsqaguwmsnv">
                      ARS 10.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-182" data-mp="1y7unsovp7v0o">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="block" data-id="element-183" data-mp="1tb46xzc2kve7">
              <div className="bg-white rounded-2xl shadow-[0_0_30px_rgba(234,179,8,0.25)] border-2 border-yellow-500 overflow-hidden relative" data-id="element-184" data-mp="1t800evb4tnkd">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-300 via-amber-500 to-yellow-300 z-20" data-id="element-185" data-mp="1k9nxpuwzqzbk"></div>
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-186" data-mp="10nutbemulakn">
                  <img src="https://cdn.magicpatterns.com/uploads/m4unkkyeQbYhT7YdQ3UiF8/Bonus_6.png" alt="Bonus 6" className="w-full h-full object-cover" data-id="element-187" data-mp="vqmadbtvl2ic" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-188" data-mp="15l4fmlexx649">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-189" data-mp="1jloz7jsoj5yt">
                    ✅ BONUS 6: GRUPO DE WHATSAPP (+714 colegas)
                  </h3>
                  <p className="text-slate-700" data-id="element-190" data-mp="1tayqixfp8klv">
                    Cuando aparece esa duda que te frena: entrás, preguntás,
                    destrabás y seguís. Además tenés bolsa de trabajo con
                    ofertas laborales de estudios jurídicos de todo el país.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-191" data-mp="1xf6h705pwamq">
                    <span className="text-slate-400 line-through font-bold" data-id="element-192" data-mp="v18m8v47fdvq">
                      ARS 24.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-193" data-mp="zzs9qzyg4xq7">
                      HOY GRATIS
                    </span>
                  </div>
                  <div className="mt-3 flex items-center justify-center gap-2 text-green-600 font-semibold" data-id="element-194" data-mp="18tyhzr9jbx61">
                    <UsersIcon className="h-5 w-5" data-id="element-195" data-mp="1dtb9ipbcpsey" />
                    <span data-id="element-196" data-mp="1ioqhx1qlaw3z">Comunidad activa</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bonuses savings summary */}
          <div className="mt-10 max-w-3xl mx-auto bg-slate-900 rounded-3xl p-8 md:p-10 text-center border-2 border-green-500 shadow-[0_0_40px_rgba(34,197,94,0.2)] relative overflow-hidden" data-id="element-197" data-mp="1rpoo9qoi3fpq">
            <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-green-400 via-green-500 to-green-400" data-id="element-198" data-mp="3thb8989z6acp"></div>
            <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-64 h-32 bg-green-500/20 rounded-full blur-3xl pointer-events-none" data-id="element-199" data-mp="3m04xuoklnf4i"></div>
            <p className="text-sm md:text-base font-bold uppercase tracking-widest text-green-400 mb-3 relative z-10" data-id="element-200" data-mp="3c8hc94aq4say">
              💰 Solo en bonus te estás llevando GRATIS
            </p>
            <div className="flex items-center justify-center gap-3 mb-3 relative z-10" data-id="element-201" data-mp="8s1u51gjfhov">
              <span className="text-2xl md:text-3xl text-slate-500 line-through font-bold" data-id="element-202" data-mp="8po2l2l2gnm2">
                ARS 98.940
              </span>
            </div>
            <p className="text-5xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-br from-green-300 via-green-400 to-green-500 leading-none mb-4 relative z-10 drop-shadow-[0_0_20px_rgba(34,197,94,0.3)]" data-id="element-203" data-mp="3vvezvcazzmia">
              ARS 0
            </p>
            <p className="inline-block bg-green-500/10 border border-green-500/30 text-green-300 font-black text-lg md:text-2xl px-6 py-3 rounded-2xl relative z-10" data-id="element-204" data-mp="2firkq7xn4qlx">
              ✅ Ahorrás ARS 98.940 en bonus — solo por hoy
            </p>
            <p className="text-sm text-slate-400 mt-4 relative z-10" data-id="element-205" data-mp="c1a3ybpp1uzc">
              6 bonus valuados en ARS 98.940, incluidos sin costo adicional con
              tu MegaPack.
            </p>
          </div>
        </div>
      </section>

      {/* Before/After Section */}
      <section className="w-full bg-gradient-to-b from-white via-slate-50 to-white py-10 px-4 relative overflow-hidden" data-id="element-206" data-mp="pzrro9fln7h9">
        <div className="absolute top-1/2 left-0 w-64 h-64 bg-red-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-207" data-mp="uy2ysceif3vs"></div>
        <div className="absolute top-1/2 right-0 w-64 h-64 bg-green-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-208" data-mp="gzbnexr17wbc"></div>
        <div className="max-w-6xl mx-auto relative z-10" data-id="element-209" data-mp="m0ixx4kk79lp">
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-8 text-center uppercase" data-id="element-210" data-mp="31p12nbvndk4k">
            ⚔️ Antes vs Después
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-211" data-mp="2y7whg1utlpur">
            <div className="bg-red-50 rounded-3xl shadow-[0_0_40px_rgba(220,38,38,0.15)] p-8 border-2 border-red-300 relative overflow-hidden" data-id="element-212" data-mp="2y6bo2fk8scyh">
              <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-red-300 via-red-500 to-red-300" data-id="element-213" data-mp="3862hedx2glwz"></div>
              <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-red-400/20 rounded-full blur-3xl" data-id="element-214" data-mp="336py235elwz5"></div>
              <h3 className="text-2xl font-black text-red-800 mb-6 uppercase text-center relative z-10" data-id="element-215" data-mp="2figfrb7efrcr">
                Antes (primer año modo supervivencia)
              </h3>
              <div className="space-y-4" data-id="element-216" data-mp="2p7q9swlszk3i">
                <div className="flex items-start gap-3" data-id="element-217" data-mp="2p8sxywrqr8fq">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-218" data-mp="2kfztma06q246" />
                  <span className="text-slate-800" data-id="element-219" data-mp="1wqxep9wxqndd">Dudas constantes</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-220" data-mp="1rru9npgygh5e">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-221" data-mp="1rrb2n3sufd65" />
                  <span className="text-slate-800" data-id="element-222" data-mp="3rt0ub9m7upaj">
                    Horas perdidas buscando modelos
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-223" data-mp="lfwqsq04oeo">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-224" data-mp="5fsixaiv4du4" />
                  <span className="text-slate-800" data-id="element-225" data-mp="9gcg2e3frhg9">
                    Miedo a errores "tontos"
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-226" data-mp="38x2arh77tzf4">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-227" data-mp="3dtj1mj5survw" />
                  <span className="text-slate-800" data-id="element-228" data-mp="3hw5v0oi4ckv7">Honorarios a ojo</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-229" data-mp="3muqxyvor9inc">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-230" data-mp="3mwk326jpzut8" />
                  <span className="text-slate-800" data-id="element-231" data-mp="x4ndt8du510b">
                    Entrevistas sin estructura
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-232" data-mp="126l3akctws1p">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-233" data-mp="1c7dmi5pkh6mk" />
                  <span className="text-slate-800" data-id="element-234" data-mp="179c47mzytbc5">
                    Sensación de "me falta algo"
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-green-50 rounded-3xl shadow-[0_0_40px_rgba(34,197,94,0.15)] p-8 border-2 border-green-500 relative overflow-hidden" data-id="element-235" data-mp="yhjz7rtpmuey">
              <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-green-300 via-green-500 to-green-300" data-id="element-236" data-mp="tjs28je7ki3w"></div>
              <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-green-400/20 rounded-full blur-3xl" data-id="element-237" data-mp="olgse8nwy7lo"></div>
              <h3 className="text-2xl font-black text-green-800 mb-6 uppercase text-center relative z-10" data-id="element-238" data-mp="fipiidaorjw5">
                Después (primer año con sistema)
              </h3>
              <div className="space-y-4" data-id="element-239" data-mp="2dvpsj0ik8zw4">
                <div className="flex items-start gap-3" data-id="element-240" data-mp="29w79kaaauyvx">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-241" data-mp="29umdgg8c77vy" />
                  <span className="text-slate-800" data-id="element-242" data-mp="2t609l2avv6ma">
                    Pasos claros y ordenados
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-243" data-mp="2jfx9yj99auez">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-244" data-mp="2jdb4cp5xeoze" />
                  <span className="text-slate-800" data-id="element-245" data-mp="2ocxdonimvl2x">
                    Material listo para aplicar
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-246" data-mp="2eg2lemcyegx3">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-247" data-mp="2ehm22e2iutze" />
                  <span className="text-slate-800" data-id="element-248" data-mp="20i46nfuq0ih2">
                    Más seguridad al presentar
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-249" data-mp="3uukjizi0uuuw">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-250" data-mp="3uv3rbndyk2v7" />
                  <span className="text-slate-800" data-id="element-251" data-mp="3mybyvs6m88r">Menos tiempo perdido</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-252" data-mp="dszllck5j49d">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-253" data-mp="8td7z20evm01" />
                  <span className="text-slate-800" data-id="element-254" data-mp="8ra8lrddcgin">
                    Honorarios con criterio
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-255" data-mp="htjkakkdifxm">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-256" data-mp="hrypquy26wzr" />
                  <span className="text-slate-800" data-id="element-257" data-mp="wksd12jkohez">
                    Entrevistas que terminan en "siguiente paso"
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What You Get Today Section */}
      <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-slate-800 via-slate-900 to-black text-white py-12 px-4 border-t-4 border-yellow-500 relative overflow-hidden" data-id="element-258" data-mp="11iahafmna8gn">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full bg-yellow-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-259" data-mp="33b8eenngfn7e"></div>
        <div className="max-w-5xl mx-auto relative z-10" data-id="element-260" data-mp="1dko91cjjcfiu">
          <div className="text-center mb-12" data-id="element-261" data-mp="1rje64s6cuf77">
            <h2 className="text-4xl md:text-6xl font-black uppercase text-yellow-400 drop-shadow-lg mb-4" data-id="element-262" data-mp="1rkfrbph34i2n">
              🧾 Todo lo que te llevás hoy
            </h2>
            <p className="text-xl text-slate-300 font-medium" data-id="element-263" data-mp="21gagl3ftdbee">
              Un sistema completo diseñado para que no tengas que improvisar
              nunca más.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-264" data-mp="2b755ygocwr42">
            {[{
            title: 'Guía Paso a Paso 2026',
            desc: 'El sistema central de procuración jurídica argentina.',
            icon: AwardIcon
          }, {
            title: 'Bonus 1: Escritos Judiciales',
            desc: 'Modelos y estructuras listas para usar.',
            icon: DownloadIcon
          }, {
            title: 'Bonus 2: Portal PJN',
            desc: 'Guía técnica para no trabarte nunca al subir escritos.',
            icon: ZapIcon
          }, {
            title: 'Bonus 3: Honorarios Prof.',
            desc: 'Criterios reales para cobrar lo que corresponde.',
            icon: ShieldIcon
          }, {
            title: 'Bonus 4: Primera Entrevista',
            desc: 'Cómo cerrar clientes y transmitir seguridad.',
            icon: UsersIcon
          }, {
            title: 'Bonus 5: Pasos Previos',
            desc: 'Checklist indispensable antes de empezar a ejercer.',
            icon: ClockIcon
          }, {
            title: 'Bonus 6: Grupo WhatsApp',
            desc: 'Acceso a +714 colegas y bolsa de trabajo en tiempo real.',
            icon: UsersIcon
          }, {
            title: 'Acceso de por vida',
            desc: 'Descarga digital inmediata y actualizaciones gratis.',
            icon: ZapIcon
          }].map((item, i) => <div key={i} className="bg-slate-800/50 border border-slate-700 rounded-2xl p-6 flex items-start gap-4 hover:bg-slate-800 hover:border-yellow-500/50 hover:shadow-[0_0_25px_rgba(234,179,8,0.15)] transition-all duration-300 group relative overflow-hidden" data-id="element-265" data-mp="225t01igq83z9" data-mpi={i}>
                <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-266" data-mp="3u3vs71mnygxl"></div>
                <div className="bg-yellow-400/10 rounded-xl p-3 group-hover:bg-yellow-400/20 transition-colors relative z-10 shadow-[0_0_15px_rgba(234,179,8,0.1)] group-hover:shadow-[0_0_20px_rgba(234,179,8,0.3)]" data-id="element-267" data-mp="qmvose3piug6">
                  <item.icon className="h-6 w-6 text-yellow-400" data-id="element-268" data-mp="hkmgzvztpf6h" />
                </div>
                <div data-id="element-269" data-mp="clt4o6w9vu7w">
                  <h3 className="text-xl font-bold text-white mb-1 group-hover:text-yellow-400 transition-colors" data-id="element-270" data-mp="cmcpbvdb4wpm">
                    {item.title}
                  </h3>
                  <p className="text-slate-400 text-sm leading-relaxed" data-id="element-271" data-mp="2xc1zvw6z9wci">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="mt-12 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-2xl p-1 shadow-2xl" data-id="element-272" data-mp="1htm9ydsqd7z1">
            <div className="bg-slate-900 rounded-[14px] py-6 px-8 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-273" data-mp="1lvh6l4zpux6h">
              <div className="flex items-center gap-4" data-id="element-274" data-mp="1qo0jdzqkxoa8">
                <div className="bg-green-500/20 rounded-full p-3" data-id="element-275" data-mp="1vm238mvtxrmr">
                  <CheckIcon className="h-8 w-8 text-green-500" data-id="element-276" data-mp="1vnwpc4iu7psf" />
                </div>
                <div data-id="element-277" data-mp="20mq563lljsvr">
                  <p className="text-white font-black text-xl md:text-2xl uppercase italic" data-id="element-278" data-mp="25jqa2b6pmpla">
                    ¡Acceso inmediato garantizado!
                  </p>
                  <p className="text-slate-400 text-sm" data-id="element-279" data-mp="29kim1c6yv8l9">
                    Recibís todo el material en tu email apenas confirmás el
                    pago.
                  </p>
                </div>
              </div>
              <div className="flex -space-x-3" data-id="element-280" data-mp="f93t6minst1a">
                {[1, 2, 3, 4, 5].map(n => <div key={n} className="h-10 w-10 rounded-full border-2 border-slate-900 bg-slate-700 flex items-center justify-center text-[10px] font-bold" data-id="element-281" data-mp="3g0otqamzpj4g">
                    {n}⭐
                  </div>)}
                <div className="h-10 px-4 rounded-full border-2 border-slate-900 bg-yellow-500 text-black flex items-center justify-center text-xs font-black" data-id="element-282" data-mp="3pylezv9n5uga">
                  +714 COLEGAS
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Preview Carousel */}
      <ProductPreviewCarousel data-id="element-283" data-mp="371jxjaywi1vg" />

      {/* Authority / Trust Section — who we are */}
      <section className="w-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-800 via-slate-900 to-black text-white py-16 px-4 border-t border-slate-800 relative overflow-hidden" data-id="element-284" data-mp="32b3jbon9ac81">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-72 bg-yellow-500/8 rounded-full blur-[100px] pointer-events-none" data-id="element-285" data-mp="29mpiz28p33tb"></div>
        <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,1) 1px, transparent 1px)',
        backgroundSize: '64px 64px'
      }} data-id="element-286" data-mp="p2u3pfl8lmrn"></div>

        <div className="max-w-6xl mx-auto relative z-10" data-id="element-287" data-mp="k5tzzbbv0w3p">
          <div className="text-center mb-12" data-id="element-288" data-mp="17ud89quwt8vs">
            <div className="inline-flex items-center gap-2 bg-yellow-500/10 border border-yellow-500/30 text-yellow-400 font-bold text-sm px-6 py-2 rounded-full mb-6 uppercase tracking-widest shadow-[0_0_20px_rgba(234,179,8,0.15)]" data-id="element-289" data-mp="17ven86f1qfis">
              <AwardIcon className="h-4 w-4" data-id="element-290" data-mp="13t9t76korgvm" /> Trayectoria y confianza
            </div>
            <h2 className="text-3xl md:text-5xl font-black uppercase text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 tracking-tight drop-shadow-[0_0_15px_rgba(234,179,8,0.2)]" data-id="element-291" data-mp="13v4eilzvdb08">
              Hecho por la comunidad de abogados más grande de Argentina
            </h2>
            <p className="text-lg md:text-xl text-slate-300 mt-4 max-w-3xl mx-auto font-light" data-id="element-292" data-mp="1p47byvc23pxy">
              Somos la comunidad creadora de soluciones para abogados y
              estudiantes de abogacía{' '}
              <span className="text-white font-semibold" data-id="element-293" data-mp="1gc5d31hmyhps">
                más importante del país
              </span>
              . Este MegaPack no lo armó cualquiera: lo construimos entre
              profesionales que viven lo mismo que vos.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-294" data-mp="16g2c3yyisp4f">
            {/* Instagram proof screenshot */}
            <div className="flex justify-center" data-id="element-295" data-mp="xdb1g1dgxxdu">
              <div className="relative group max-w-[300px]" data-id="element-296" data-mp="xem4u030534f">
                <div className="absolute inset-0 bg-yellow-500/15 rounded-[2rem] blur-2xl group-hover:bg-yellow-500/25 transition-all duration-500" data-id="element-297" data-mp="2vsximn4bnqvi"></div>
                <div className="relative bg-slate-900/80 backdrop-blur-xl rounded-[2rem] border border-yellow-500/30 p-2.5 shadow-[0_0_40px_rgba(234,179,8,0.15)] overflow-hidden" data-id="element-298" data-mp="2roy3o8yox049">
                  <img src="https://cdn.magicpatterns.com/uploads/izoafXB3EzoUwuxyggz4Dw/image.png" alt="Perfil verificado de la comunidad Estudiantes de Abogacía Argentina con 33.1 mil seguidores" className="w-full h-auto rounded-[1.5rem]" data-id="element-299" data-mp="igtdzzdrndqc" />
                </div>
                <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-blue-500 text-white text-xs font-black px-4 py-1.5 rounded-full shadow-lg whitespace-nowrap border border-blue-300/40" data-id="element-300" data-mp="3qql739jpkwmp">
                  ✓ Cuenta verificada
                </div>
              </div>
            </div>

            {/* Stats + scarcity */}
            <div className="space-y-6" data-id="element-301" data-mp="8lrnp07r85m6">
              <div className="grid grid-cols-2 gap-4" data-id="element-302" data-mp="1f0af7lzyr39r">
                <div className="bg-slate-800/50 border border-slate-700/50 rounded-2xl p-6 text-center" data-id="element-303" data-mp="1ezqwi32hoauo">
                  <p className="md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-br from-yellow-200 to-yellow-500 text-[30px]" data-id="element-304" data-mp="1jxiqr3qlw921">
                    +33.100
                  </p>
                  <p className="text-sm text-slate-400 font-medium mt-1" data-id="element-305" data-mp="qpjlugtf7kg4">
                    profesionales de todo Argentina
                  </p>
                </div>
                <div className="bg-slate-800/50 border border-green-500/30 rounded-2xl p-6 text-center shadow-[0_0_20px_rgba(34,197,94,0.1)]" data-id="element-306" data-mp="znc33qipd265">
                  <p className="text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-br from-green-300 to-green-500" data-id="element-307" data-mp="1efdx4ty3d0y9">
                    714
                  </p>
                  <p className="text-sm text-slate-400 font-medium mt-1" data-id="element-308" data-mp="1nd6d80bn0cmp">
                    con acceso al grupo privado
                  </p>
                </div>
              </div>

              <div className="bg-green-500/10 border border-green-500/30 rounded-2xl p-6 shadow-[0_0_20px_rgba(34,197,94,0.1)]" data-id="element-309" data-mp="3p5ukqlvbdm8a">
                <p className="text-base md:text-lg text-green-200 font-bold leading-relaxed" data-id="element-310" data-mp="3l63m5vzjq1t7">
                  🔒 De más de <span className="text-white" data-id="element-311" data-mp="3f1e61vtkmb62">33.100</span>{' '}
                  miembros, solo <span className="text-green-300" data-id="element-312" data-mp="3f3i786034w2n">714</span>{' '}
                  tienen el privilegio de interactuar a diario en el grupo
                  privado de WhatsApp — y hoy podés ser uno de ellos al realizar
                  tu compra.
                </p>
              </div>

              {/* Trust pillars */}
              <div className="grid grid-cols-3 gap-3" data-id="element-313" data-mp="2wawcxq4ttdk6">
                {[{
                icon: AwardIcon,
                label: 'Trayectoria'
              }, {
                icon: ShieldIcon,
                label: 'Seguridad'
              }, {
                icon: CheckIcon,
                label: 'Transparencia'
              }].map((p, i) => <div key={i} className="bg-slate-800/40 border border-slate-700/50 rounded-xl p-4 flex flex-col items-center gap-2 text-center" data-id="element-314" data-mp="gl37jrvlabef" data-mpi={i}>
                    <p.icon className="h-6 w-6 text-yellow-400" data-id="element-315" data-mp="lgigc5eqph3z" />
                    <span className="text-xs md:text-sm font-bold text-slate-200" data-id="element-316" data-mp="1nc2ep64ndzqc">
                      {p.label}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Community Section — desire + urgency before the offer */}
      <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black text-white py-16 px-4 border-t border-slate-800 relative overflow-hidden" data-id="element-317" data-mp="221i2cd8vtp1t">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-green-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-318" data-mp="2b1wr5ml21ma2"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-yellow-500/8 rounded-full blur-[100px] pointer-events-none" data-id="element-319" data-mp="2kyt1lxuikih9"></div>

        <div className="max-w-6xl mx-auto relative z-10" data-id="element-320" data-mp="lmgrcxt0tcwu">
          <div className="text-center mb-12" data-id="element-321" data-mp="qjyrbyp28hsp">
            <div className="inline-flex items-center gap-2 bg-green-500/10 border border-green-500/30 text-green-400 font-bold text-sm px-6 py-2 rounded-full mb-6 uppercase tracking-widest shadow-[0_0_20px_rgba(34,197,94,0.15)]" data-id="element-322" data-mp="qks1zar53rg4">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-323" data-mp="2z1ynfyqpceuo"></span>
              Comunidad activa
            </div>
            <h2 className="text-3xl md:text-5xl font-black uppercase text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 tracking-tight drop-shadow-[0_0_15px_rgba(234,179,8,0.2)]" data-id="element-324" data-mp="2q3wgz3o78u00">
              La red de abogados más importante de Argentina
            </h2>
            <p className="text-lg md:text-xl text-slate-300 mt-4 max-w-3xl mx-auto font-light" data-id="element-325" data-mp="3drwjf0uvi8uf">
              Ya somos más de{' '}
              <span className="text-green-400 font-black" data-id="element-326" data-mp="38t32eygdnzpi">714 colegas</span>,
              noveles abogados y estudiantes de derecho de toda la República
              Argentina resolviendo problemas, consiguiendo trabajo y pidiendo
              ayuda. No comprás solo un material: entrás a una red que te
              respalda{' '}
              <span className="text-white font-semibold" data-id="element-327" data-mp="23upqfeg6l5v9">todos los días</span>.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-328" data-mp="1pv6url4k3mzu">
            {/* Community card image */}
            <div className="relative group" data-id="element-329" data-mp="1uti47uqxvvhj">
              <div className="absolute inset-0 bg-green-500/15 rounded-3xl blur-2xl group-hover:bg-green-500/25 transition-all duration-500" data-id="element-330" data-mp="1usgjeyk4fumm"></div>
              <div className="relative bg-slate-900/80 backdrop-blur-xl rounded-3xl border border-green-500/30 p-4 shadow-[0_0_40px_rgba(34,197,94,0.15)] overflow-hidden" data-id="element-331" data-mp="1kvk86l2u8ued">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-green-400 via-green-500 to-green-400" data-id="element-332" data-mp="172m4mbg8rvzq"></div>
                <img src="https://cdn.magicpatterns.com/uploads/dMA9u4fFe9VicheKNfNZuH/image.png" alt="Grupo de WhatsApp Abogados y Estudiantes de Abogacía Argentina — 714 miembros" className="w-full h-auto rounded-2xl" data-id="element-333" data-mp="x5puy2elx3tl" />
                <div className="mt-4 flex items-center justify-center gap-3 pb-2" data-id="element-334" data-mp="iklqdral0bll">
                  <div className="flex -space-x-2" data-id="element-335" data-mp="dl953azczcl4">
                    {[1, 2, 3, 4].map(n => <div key={n} className="h-8 w-8 rounded-full border-2 border-slate-900 bg-slate-700 flex items-center justify-center text-[9px] font-bold" data-id="element-336" data-mp="shqcxs8ca92x">
                        {n}⭐
                      </div>)}
                  </div>
                  <p className="text-sm text-slate-300 font-semibold" data-id="element-337" data-mp="11h3rv0f8fpv1">
                    <span className="text-green-400 font-black" data-id="element-338" data-mp="wjv8wxm9fhsq">+714</span>{' '}
                    colegas ya adentro
                  </p>
                </div>
              </div>
            </div>

            {/* Benefits */}
            <div className="space-y-4" data-id="element-339" data-mp="16ag3m9ytc26d">
              {[{
              icon: ZapIcon,
              title: 'Soporte en vivo todos los días',
              desc: 'Tirás tu duda y destrabás el caso en minutos, no en semanas.'
            }, {
              icon: UsersIcon,
              title: 'Red de contactos en todas las provincias',
              desc: 'Colegas de toda Argentina listos para ayudarte con averiguaciones y trámites locales.'
            }, {
              icon: ShieldIcon,
              title: 'Soluciones casi inmediatas',
              desc: 'Ante una inseguridad o situación complicada en un caso, nunca estás solo.'
            }, {
              icon: BriefcaseIcon,
              title: 'Bolsa de trabajo exclusiva',
              desc: 'Estudios jurídicos de todo el país nos envían sus ofertas laborales y las publicamos en el grupo de WhatsApp.'
            }, {
              icon: AwardIcon,
              title: 'Networking que vale oro',
              desc: 'Contactos, derivaciones y oportunidades reales que esta red genera todos los días.'
            }].map((item, i) => <div key={i} className="flex items-start gap-4 bg-slate-800/40 backdrop-blur-md border border-slate-700/50 rounded-2xl p-5 hover:border-green-500/40 hover:bg-slate-800/60 transition-all duration-300" data-id="element-340" data-mp="fycnub6r1jop" data-mpi={i}>
                  <div className="bg-green-500/15 rounded-xl p-3 flex-shrink-0 shadow-[0_0_15px_rgba(34,197,94,0.1)]" data-id="element-341" data-mp="24i8ndz3zm65c">
                    <item.icon className="h-6 w-6 text-green-400" data-id="element-342" data-mp="20jj4jr06jweb" />
                  </div>
                  <div data-id="element-343" data-mp="1voc7h21f1pyd">
                    <h3 className="text-lg font-bold text-white mb-1" data-id="element-344" data-mp="1qrdh8ukvi35g">
                      {item.title}
                    </h3>
                    <p className="text-sm text-slate-400 leading-relaxed" data-id="element-345" data-mp="1ltbvu2zz5rqt">
                      {item.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Urgency + value line */}
          <div className="mt-12 bg-red-500/10 border border-red-500/30 rounded-2xl p-6 text-center max-w-3xl mx-auto" data-id="element-346" data-mp="1ctfdsk83br4q">
            <p className="text-lg md:text-xl font-bold text-red-300" data-id="element-347" data-mp="375bxts47dupr">
              ⚠️ El acceso a la comunidad está incluido solo dentro de la oferta
              de hoy. Esta red de contactos ya de por sí es invaluable — y
              merecés formar parte de ella.
            </p>
          </div>

          <div className="flex justify-center mt-8" data-id="element-348" data-mp="3q1lxqhwf74nw">
            <a href="#compra" onClick={scrollToOffer} className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-lg md:text-2xl px-12 py-6 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.3)] hover:shadow-[0_0_50px_rgba(34,197,94,0.5)] transform hover:scale-105 transition-all duration-300 uppercase text-center border-2 border-green-400" data-id="element-349" data-mp="3q3f7i62by504">
              QUIERO ENTRAR A LA COMUNIDAD
            </a>
          </div>
        </div>
      </section>

      {/* Urgency Module — right before the offer */}
      <UrgencyModule data-id="element-350" data-mp="3unnfhlejv4f" />

      {/* Pricing Section — CHECKOUT DIRECTO */}
      <section id="compra" className="w-full bg-[#f8fafc] py-14 px-4 relative overflow-hidden" data-id="element-351" data-mp="3st2i3a4s30c">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-300 to-transparent" data-id="element-352" data-mp="2jkgvjnm0xbdv"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full bg-yellow-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-353" data-mp="2h1c4lpxzkhho"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-354" data-mp="2c4dcfcxvukm4">
          {/* Urgency badge */}
          <div className="inline-flex items-center gap-2 bg-red-600 text-white font-black text-sm px-6 py-2.5 rounded-full mb-8 uppercase tracking-widest shadow-[0_0_20px_rgba(220,38,38,0.3)] animate-pulse" data-id="element-355" data-mp="2pzxuk65seysh">
            🔥 Oferta por tiempo limitado
          </div>

          <h2 className="text-4xl md:text-6xl font-black text-slate-900 mb-4 uppercase text-center tracking-tight" data-id="element-356" data-mp="1td2nh1bpwhwv">
            Invertí en tu carrera hoy
          </h2>
          <p className="text-xl md:text-2xl text-slate-600 mb-12 text-center font-light" data-id="element-357" data-mp="22bxv8hueu02a">
            Todo lo que necesitás para ejercer con{' '}
            <span className="font-bold text-slate-900" data-id="element-358" data-mp="1el26xup5xmzs">seguridad</span> desde el
            día 1
          </p>

          <div className="bg-white rounded-[2.5rem] shadow-[0_20px_60px_-15px_rgba(0,0,0,0.1),0_0_40px_rgba(234,179,8,0.15)] overflow-hidden border border-slate-100 mb-10 relative" data-id="element-359" data-mp="19lpmfglrks0d">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-400" data-id="element-360" data-mp="t428vh4coaag"></div>
            <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-yellow-50/50 via-white to-white opacity-100 pointer-events-none" data-id="element-361" data-mp="y4zp3o5suu9b"></div>

            {/* Top ribbon */}
            <div className="bg-slate-900 py-4 px-6 relative z-10 shadow-md" data-id="element-362" data-mp="1c1mnlvdehshc">
              <p className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 font-black text-lg md:text-xl uppercase text-center tracking-widest" data-id="element-363" data-mp="1gteigi3lakda">
                ⚖️ Oferta especial — Guía + 6 Bonus incluidos ⚖️
              </p>
            </div>

            <div className="p-8 md:p-12 relative z-10" data-id="element-364" data-mp="1vqf0ftvzb0yk">
              {/* Main product preview */}
              <div className="flex justify-center mb-8" data-id="element-365" data-mp="3g8g3cqm8dy7r">
                <img src="https://cdn.magicpatterns.com/uploads/iJJdpCyfxh5BQG3hJzFyXz/PRESENTACION_ERICA_Y_JIME_-_VIERNES_12_DE_JUNIO.png" alt="Mega Pack de Procuración Jurídica 2026 con 6 bonus" className="w-full max-w-lg h-auto drop-shadow-xl" data-id="element-366" data-mp="3ga0vk9l2p52g" />
              </div>

              {/* Benefits grid */}
              

              {/* Everything included summary */}
              <div className="bg-slate-50 border border-slate-200 rounded-2xl p-6 md:p-8 mb-8 text-left" data-id="element-367" data-mp="2tt7sewysnof">
                <div className="text-center mb-6" data-id="element-368" data-mp="3u0vzr8kmmxzp">
                  <p className="text-sm font-black uppercase tracking-widest text-green-700 mb-2" data-id="element-369" data-mp="3u274balwc9rv">
                    Resumen de tu compra
                  </p>
                  <h3 className="text-2xl md:text-3xl font-black text-slate-900" data-id="element-370" data-mp="3k9i4jczpkkcd">
                    Todo lo que te llevás hoy
                  </h3>
                </div>
                <ul className="grid md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-371" data-mp="gt2l96tsd3op">
                  {['Guía Paso a Paso de Procuración Jurídica 2026', 'Bonus 1: Escritos Judiciales Paso a Paso', 'Bonus 2: Guía para subir escritos al Portal PJN', 'Bonus 3: Guía práctica de honorarios profesionales', 'Bonus 4: Tu primera entrevista con clientes', 'Bonus 5: Pasos previos al ejercicio profesional', 'Bonus 6: Grupo privado de WhatsApp con +714 colegas', 'Bolsa de trabajo con ofertas de estudios jurídicos', 'Acceso inmediato, descarga digital y de por vida', 'Garantía de devolución total por 14 días'].map(benefit => <li key={benefit} className="flex items-start gap-3 text-sm md:text-base text-slate-700 font-medium leading-relaxed" data-id="element-372" data-mp="2m2j8mfan9jw9">
                      <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-green-100" data-id="element-373" data-mp="2harpuqxqcigo">
                        <CheckIcon className="h-3.5 w-3.5 text-green-700" aria-hidden="true" data-id="element-374" data-mp="2cbf3s8eonff5" />
                      </span>
                      <span data-id="element-375" data-mp="3526uiqczbbv3">{benefit}</span>
                    </li>)}
                </ul>
                <div className="mt-6 border-t border-slate-200 pt-5 flex items-start gap-3" data-id="element-376" data-mp="3cd1u8pkb2lgl">
                  <UsersIcon className="h-6 w-6 text-green-700 flex-shrink-0" aria-hidden="true" data-id="element-377" data-mp="3hc4yw8wdipo1" />
                  <p className="text-sm md:text-base text-green-900 font-bold leading-relaxed" data-id="element-378" data-mp="3mb95crrwy9ao">
                    Además de los materiales, entrás a la comunidad de WhatsApp
                    más grande de abogados y estudiantes de abogacía de
                    Argentina.
                  </p>
                </div>
              </div>

              {/* Price comparison — shown after the included-items summary */}
              <div className="mb-6 text-center" data-id="element-379" data-mp="8vtdya587tnz">
                <p className="text-lg md:text-2xl line-through mb-2 font-medium text-[#E10A14]" data-id="element-380" data-mp="8x4piw4wy5pn">
                  Precio regular: ARS 87.500
                </p>
                <p className="text-lg md:text-2xl font-black text-slate-800 uppercase tracking-tight mb-1" data-id="element-381" data-mp="hxswx7zsx7tk">
                  Hoy accedés a todo por:
                </p>
                <p className="text-5xl md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-br from-green-500 to-green-700 drop-shadow-sm" data-id="element-382" data-mp="2iyzf7uqkwrpm">
                  ARS 34.999
                </p>
              </div>

              {/* Savings badge */}
              <div className="flex justify-center mb-8" data-id="element-383" data-mp="2sqd99mzrgzbd">
                <div className="inline-flex items-center gap-2 bg-green-50 border border-green-200 text-green-700 font-black text-xl md:text-2xl px-8 py-3 rounded-2xl shadow-sm" data-id="element-384" data-mp="2ny3n8i1rojed">
                  Ahorrás: ARS 52.500
                </div>
              </div>

              {/* Installments — small standout pill right above CTA */}
              <div className="flex justify-center mb-4" data-id="element-385" data-mp="3bneg7dcvl9hy">
                <div className="inline-flex items-center gap-1.5 bg-green-50 border border-green-300 rounded-full py-1.5 px-4 shadow-[0_0_15px_rgba(34,197,94,0.15)]" data-id="element-386" data-mp="36obmgp2cippa">
                  <p className="text-xs md:text-sm font-bold text-slate-700 text-center" data-id="element-387" data-mp="1hbqa80omgh9p">
                    💳 Pagá en hasta{' '}
                    <span className="text-green-600 font-black" data-id="element-388" data-mp="3nxnnof68lwb3">3 cuotas</span>{' '}
                    — Acceso inmediato
                  </p>
                </div>
              </div>

              {/* CTA Button */}
              <div className="flex justify-center mb-4 relative z-10" data-id="element-389" data-mp="3f4sreayqzaxg">
                <a href="https://megapacknovelesabogados.impultienda.ar/" className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-xl md:text-3xl px-12 py-6 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.4)] hover:shadow-[0_0_50px_rgba(34,197,94,0.6)] transform hover:scale-105 transition-all duration-300 animate-pulse-slow uppercase text-center border-2 border-green-400" data-id="element-390" data-mp="3j779utyi88o7">
                  QUIERO ACCEDER AHORA + 14 DIAS DE GARANTIA ⭐
                </a>
              </div>

              {/* Payment & security badges */}
              <div className="flex justify-center mb-4" data-id="element-391" data-mp="udihm77ti46d">
                <img src="https://cdn.magicpatterns.com/uploads/na8BuWPBQNjFajZ2AV1MpB/pasted-image.jpg" alt="Mercado Pago, VISA, Mastercard — Compra 100% segura, SSL certificado" className="w-full max-w-xs h-auto rounded-2xl border border-slate-200 shadow-sm" data-id="element-392" data-mp="yg6rmi89ph4x" />
              </div>

              <p className="text-base font-bold text-slate-700 text-center" data-id="element-393" data-mp="3vx91z7o1dtnl">
                ✔ Válido para toda Argentina 🇦🇷
              </p>
            </div>
          </div>

          {/* Guarantee */}
          <div className="max-w-2xl mx-auto bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black rounded-3xl px-8 py-12 md:px-12 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.4)] border border-slate-800 relative overflow-hidden" data-id="element-394" data-mp="3mxc9euyj0an9">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-72 h-40 bg-green-500/15 rounded-full blur-3xl pointer-events-none" data-id="element-395" data-mp="3887rlevn88fo"></div>

            {/* Guarantee seal */}
            <div className="flex justify-center mb-6 relative z-10" data-id="element-396" data-mp="33b7hmsvoalja">
              <img src="https://cdn.magicpatterns.com/uploads/madg1qercsqVrLH7D3t9xB/14_dias_de_garantia.png" alt="Sello de garantía de 14 días" className="h-32 w-32 object-contain drop-shadow-[0_0_24px_rgba(234,179,8,0.35)] md:h-36 md:w-36" data-id="element-397" data-mp="2z8szyc3qprtl" />
            </div>

            {/* Heading */}
            <h3 className="text-2xl md:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 uppercase text-center tracking-tight mb-8 drop-shadow-[0_0_15px_rgba(234,179,8,0.2)] relative z-10" data-id="element-398" data-mp="1nr6ybo6ukk9j">
              Garantía 14 días — Sin preguntas
            </h3>

            {/* Inner glowing card */}
            <div className="rounded-2xl border border-green-500/40 bg-slate-900/60 backdrop-blur-md px-6 py-8 md:px-10 text-center shadow-[0_0_30px_rgba(34,197,94,0.12)] relative z-10" data-id="element-399" data-mp="14znwvlsh1e9m">
              <p className="text-base md:text-lg text-slate-300 mb-4 font-medium" data-id="element-400" data-mp="19s79afffa3cu">
                Abrís el material. Lo usás en tus casos reales.
              </p>
              <p className="text-base md:text-lg text-slate-300 mb-6 font-medium" data-id="element-401" data-mp="h8s4onk3sh1u">
                Si en 14 días no es exactamente lo que esperabas:
              </p>
              <p className="text-3xl md:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-300 via-green-400 to-green-300 mb-4 drop-shadow-[0_0_15px_rgba(34,197,94,0.3)]" data-id="element-402" data-mp="58brs4qp6yys">
                devolución del 100%
              </p>
              <p className="text-lg md:text-xl font-bold text-white" data-id="element-403" data-mp="e26xbdvqerey">
                sin formularios, sin drama, sin explicaciones.
              </p>
            </div>

            {/* Footer line */}
            <p className="text-sm text-slate-500 text-center mt-8 font-medium tracking-wide relative z-10" data-id="element-404" data-mp="3igeuboj0wqcu">
              Tasa de devoluciones:{' '}
              <span className="text-green-400 font-bold" data-id="element-405" data-mp="3reqryaib4oes">menos del 1%</span>.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="w-full bg-white py-14 px-4 relative overflow-hidden" data-id="element-406" data-mp="16ormq8snctfv">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent" data-id="element-407" data-mp="16qvp2mawdke1"></div>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-64 bg-amber-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-408" data-mp="2tl939ss31u56"></div>
        <div className="max-w-6xl mx-auto relative z-10" data-id="element-409" data-mp="2fnar8u18i9su">
          <div className="text-center mb-16" data-id="element-410" data-mp="2kkaxp61zxekh">
            <span className="inline-block bg-yellow-100 text-yellow-800 font-bold px-4 py-1.5 rounded-full text-sm uppercase tracking-widest mb-4" data-id="element-411" data-mp="2kl2qk947ky72">
              Casos de éxito
            </span>
            <h2 className="text-3xl md:text-5xl font-black text-slate-900 text-center uppercase tracking-tight" data-id="element-412" data-mp="3cb77fxsrf33j">
              Lo que dicen otros noveles abogados
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-413" data-mp="33i3urrpxuu9y">
            {[{
            name: 'Valentina Rodríguez',
            age: 25,
            city: 'Buenos Aires',
            image: 'https://cdn.magicpatterns.com/uploads/wkC9mjEkjQQfEdnDWJ1H1d/valentina.jpg.png',
            text: '"Me ordenó la cabeza completamente. Dejé de tardar horas en cosas básicas y ahora presento escritos con confianza."'
          }, {
            name: 'Matías González',
            age: 27,
            city: 'Córdoba',
            image: 'https://cdn.magicpatterns.com/uploads/m2912Cds5tKdEYAue64tUW/matias.jpg.png',
            text: '"El paso a paso del PJN me ahorró errores reales. Lo recomiendo a cualquier novel que esté empezando."'
          }, {
            name: 'Lucía Fernández',
            age: 26,
            city: 'Rosario',
            image: 'https://cdn.magicpatterns.com/uploads/sCchiBEesCWkuw5ms9Y6EB/lucia.jpg.png',
            text: '"Por fin entendí cómo cobrar mis honorarios sin sentirme incómoda. Vale cada peso."'
          }, {
            name: 'Sebastián Torres',
            age: 28,
            city: 'Mendoza',
            image: 'https://cdn.magicpatterns.com/uploads/1CdsTqvVXAugSnu8uDPbxF/sebastian.jpg.png',
            text: '"La guía de la primera entrevista me cambió todo. Ahora salgo con próximos pasos claros siempre."'
          }, {
            name: 'Camila Martínez',
            age: 25,
            city: 'Tucumán',
            image: 'https://cdn.magicpatterns.com/uploads/vtowfDwECZq5y7m6p4tgrN/camila.jpg.png',
            text: '"Dejé de improvisar. Tengo un sistema real para ejercer y eso me da una seguridad que antes no tenía."'
          }, {
            name: 'Joaquín Pereyra',
            age: 26,
            city: 'La Plata',
            image: 'https://cdn.magicpatterns.com/uploads/r2327LZGc8i9MrLaxqz95v/joaquin.jpg.png',
            text: '"Pensé que iba a ser otro PDF más y me sorprendió mucho. Lo del PJN sobre todo, lo apliqué la misma semana y me funcionó."'
          }, {
            name: 'Florencia Acosta',
            age: 27,
            city: 'Salta',
            image: 'https://cdn.magicpatterns.com/uploads/7jjyhdHTjq5VHart9qNsQr/florencia.jpg.png',
            text: '"Recién recibida, sin estudio donde caerme. Esta guía fue la mano que necesitaba. Hoy facturo mejor y trabajo más tranquila."'
          }, {
            name: 'Tomás Iriarte',
            age: 24,
            city: 'Bahía Blanca',
            image: 'https://cdn.magicpatterns.com/uploads/bjwzjLXsH3KVkqbHyu17tL/tomas.jpg.png',
            text: '"Lo bueno es que no es teoría boba. Es lo que necesitás cuando estás en el medio del lío y no sabés qué hacer. Súper práctico."'
          }, {
            name: 'Antonella Vega',
            age: 28,
            city: 'Neuquén',
            image: 'https://cdn.magicpatterns.com/uploads/qhSBycTb2jpibgZCAaVPtQ/antonella.jpg.png',
            text: '"El grupo de WhatsApp solo ya vale la inversión. Te sacás dudas al toque con colegas que están en la misma."'
          }, {
            name: 'Bruno Salinas',
            age: 26,
            city: 'Posadas',
            image: 'https://cdn.magicpatterns.com/uploads/2hZ5ntc4ypLZN7peSHuS9V/ChatGPT_Image_10_sept_2026,_01_10_41_(3).png',
            text: '"Lo compré medio desconfiado, pero la verdad lo recomiendo. Me ordenó todo y dejé de sentirme perdido en cada trámite."'
          }, {
            name: 'Camila T.',
            age: 25,
            city: 'Córdoba Capital, Córdoba',
            image: 'https://cdn.magicpatterns.com/uploads/rhZS9dDmDM9693mUfCmeBH/ChatGPT_Image_10_sept_2026,_01_10_42_(6).png',
            text: '"Me recibí hace 6 meses y la verdad es que la facultad te enseña mucha teoría, pero no te enseña a pisar tribunales. Tenía terror de mandar mal un escrito o que se me pase un plazo por no saber leer el proveído. Este material fue mi salvavidas. Entendí el paso a paso de cómo se mueve un expediente en la vida real. Recomendadísimo para los que recién arrancamos."'
          }, {
            name: 'Martín S.',
            age: 23,
            city: 'La Plata, Provincia de Buenos Aires',
            image: 'https://cdn.magicpatterns.com/uploads/7Dj4Kw6FfW8AaWhM1ryEwG/ChatGPT_Image_10_sept_2026,_01_10_42_(4).png',
            text: '"Entré a trabajar a un estudio grande como procurador y el primer mes estaba perdidísimo, sobre todo con el sistema electrónico y las notificaciones. Compré la guía para no tener que estar preguntándole todo a los abogados senior. Me resolvió el día a día. Los tips para lidiar con mesa de entradas valen oro puro."'
          }, {
            name: 'Luciana G.',
            age: 27,
            city: 'Rosario, Santa Fe',
            image: 'https://cdn.magicpatterns.com/uploads/3xwL1WkmRNg28sMHTCqKTY/ChatGPT_Image_10_sept_2026,_01_10_42_(8).png',
            text: '"Agarré mi primer caso propio, una sucesión familiar, y tenía pánico de meter la pata. La teoría la sabía, pero el cómo se hace no. Lo que más destaco del producto son los modelos prácticos y la explicación de cómo armar y presentar los trámites básicos. Me dio muchísima seguridad para ir al juzgado."'
          }, {
            name: 'Federico R.',
            age: 24,
            city: 'San Miguel de Tucumán, Tucumán',
            image: 'https://cdn.magicpatterns.com/uploads/cAE2BfumPcCLer5sEDtihY/ChatGPT_Image_10_sept_2026,_01_10_42_(5).png',
            text: '"Todavía me faltan 4 materias pero ya quería empezar a hacer procuración para ir ganando experiencia y algo de plata. El problema es que nadie tiene tiempo para enseñarte desde cero. Este material es literal el manual de supervivencia que te falta en la universidad. Ya estoy procurándole a dos abogados amigos de mi viejo sin problemas."'
          }, {
            name: 'Sofía L.',
            age: 26,
            city: 'CABA',
            image: 'https://cdn.magicpatterns.com/uploads/oPibAvL58JtnN3GR3JAzFY/ChatGPT_Image_10_sept_2026,_01_10_43_(10).png',
            text: '"Siempre me daba vergüenza preguntar en mesa de entradas o mandar mal una cédula porque te miran con cara de esto ya lo deberías saber. Comprar esto me quitó esa ansiedad. Es súper directo, al grano y te explica los trucos procesales que solo aprendés a los golpes. Se pagó solo con el tiempo que me ahorró."'
          }, {
            name: 'Juan Ignacio M.',
            age: 28,
            city: 'Mendoza Capital, Mendoza',
            image: 'https://cdn.magicpatterns.com/uploads/3kvb8LntoriY2sgdMQgh5S/ChatGPT_Image_10_sept_2026,_01_10_42_(7).png',
            text: '"Por el precio que tiene, la información es un regalo. Es exactamente lo que necesitás saber la primera semana de matriculado. Había cosas de las presentaciones electrónicas y la vinculación de causas que no cazaba ni una. Lo leí en un fin de semana y el lunes ya estaba subiendo escritos con token sin transpirar."'
          }, {
            name: 'Valeria D.',
            age: 29,
            city: 'Mar del Plata, Provincia de Buenos Aires',
            image: 'https://cdn.magicpatterns.com/uploads/fRAk4zpVo6i9NF76YEgC39/ChatGPT_Image_10_sept_2026,_01_10_41_(1).png',
            text: '"Excelente inversión. Me sirvió un montón para ordenar la cabeza. A veces uno se ahoga en un vaso de agua por un mero trámite administrativo o un oficio mal confeccionado. Ver los ejemplos reales y el paso a paso me bajó mil revoluciones. Ahora voy sabiendo exactamente qué tengo que pedir y dónde."'
          }, {
            name: 'Agustín P.',
            age: 26,
            city: 'Neuquén Capital, Neuquén',
            image: 'https://cdn.magicpatterns.com/uploads/tzKGz2WLTSS4CmE7R9abm4/ChatGPT_Image_10_sept_2026,_01_10_42_(9).png',
            text: '"Me lo recomendó una compañera de la facu porque estaba muy frustrado; me habían rebotado dos veces un escrito en un juzgado civil por errores de forma. El producto va directo al dolor del abogado junior: la práctica pura y dura. Desde que aplico lo que explican acá, los expedientes me empezaron a caminar mucho más rápido."'
          }, {
            name: 'Micaela B.',
            age: 30,
            city: 'Salta Capital, Salta',
            image: 'https://cdn.magicpatterns.com/uploads/9mJnjM1KfMs5MjqbQL1KQZ/ChatGPT_Image_10_sept_2026,_01_10_41_(2).png',
            text: '"Lo compré con dudas porque ya había hecho un curso de práctica profesional que fue pura teoría otra vez. Pero esto es diferente, es 100% la calle de tribunales. Te cuentan la realidad, cómo agilizar trámites y cómo no perder tiempo haciendo filas inútiles. A cualquier colega que esté dando sus primeros pasos se lo recomiendo a ciegas."'
          }, {
            name: 'Tomás C.',
            age: 22,
            city: 'Corrientes Capital, Corrientes',
            text: '"Trabajo medio día en un estudio jurídico y me pasaba horas tratando de entender cómo diligenciar los oficios y los mandamientos sin mandarme ninguna macana. El material es súper didáctico, sin palabras raras, va al hueso. Resolví dudas que arrastraba hace meses en dos tardes de lectura."'
          }, {
            name: 'Valentina Rodríguez',
            age: 25,
            city: 'Buenos Aires',
            text: '"Me ordenó la cabeza completamente. Dejé de tardar horas en cosas básicas y ahora presento escritos con confianza."'
          }, {
            name: 'Matías González',
            age: 27,
            city: 'Córdoba',
            text: '"El paso a paso del PJN me ahorró errores reales. Lo recomiendo a cualquier novel que esté empezando."'
          }, {
            name: 'Lucía Fernández',
            age: 26,
            city: 'Rosario',
            text: '"Por fin entendí cómo cobrar mis honorarios sin sentirme incómoda. Vale cada peso."'
          }, {
            name: 'Sebastián Torres',
            age: 28,
            city: 'Mendoza',
            text: '"La guía de la primera entrevista me cambió todo. Ahora salgo con próximos pasos claros siempre."'
          }, {
            name: 'Camila Martínez',
            age: 25,
            city: 'Tucumán',
            text: '"Dejé de improvisar. Tengo un sistema real para ejercer y eso me da una seguridad que antes no tenía."'
          }, {
            name: 'Joaquín Pereyra',
            age: 26,
            city: 'La Plata',
            text: '"Pensé que iba a ser otro PDF más y me sorprendió mucho. Lo del PJN sobre todo, lo apliqué la misma semana y me funcionó."'
          }, {
            name: 'Florencia Acosta',
            age: 27,
            city: 'Salta',
            text: '"Recién recibida, sin estudio donde caerme. Esta guía fue la mano que necesitaba. Hoy facturo mejor y trabajo más tranquila."'
          }, {
            name: 'Tomás Iriarte',
            age: 24,
            city: 'Bahía Blanca',
            text: '"Lo bueno es que no es teoría boba. Es lo que necesitás cuando estás en el medio del lío y no sabés qué hacer. Súper práctico."'
          }, {
            name: 'Antonella Vega',
            age: 28,
            city: 'Neuquén',
            text: '"El grupo de WhatsApp solo ya vale la inversión. Te sacás dudas al toque con colegas que están en la misma."'
          }, {
            name: 'Bruno Salinas',
            age: 26,
            city: 'Posadas',
            text: '"Lo compré medio desconfiado, pero la verdad lo recomiendo. Me ordenó todo y dejé de sentirme perdido en cada trámite."'
          }].map((t, i) => <div key={i} className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] hover:shadow-[0_0_30px_rgba(234,179,8,0.15)] hover:-translate-y-1 transition-all duration-300 p-8 border border-slate-200" data-id="element-414" data-mp="3qsrw4ak3z9yg" data-mpi={i}>
                {t.image && <img src={t.image} alt={`Retrato de ${t.name}`} className="w-20 h-20 mx-auto mb-4 rounded-full object-cover object-center border-4 border-white shadow-md ring-2 ring-yellow-400" data-id="element-415" data-mp="2y6fj76femb87" />}
                <div className="flex gap-1 mb-4 justify-center" data-id="element-416" data-mp="3324akmh9sltf">
                  {[...Array(5)].map((_, j) => <StarIcon key={j} className="h-5 w-5 text-yellow-500 fill-yellow-500" data-id="element-417" data-mp="nb9ni0wihywz" data-mpi={j} />)}
                </div>
                <p className="text-slate-700 mb-4 italic text-center" data-id="element-418" data-mp="id86rmmk6boo">
                  {t.text}
                </p>
                <div className="border-t pt-4 text-center border-slate-200" data-id="element-419" data-mp="11s6chp40nw1q">
                  <p className="font-bold text-slate-900" data-id="element-420" data-mp="wqqu64t843n1">{t.name}</p>
                  <p className="text-sm text-slate-600" data-id="element-421" data-mp="1bnhssbv2pbbl">
                    {t.age} años — Abogado/a (1er año) — {t.city}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full bg-gradient-to-b from-white via-slate-50 to-white py-10 px-4 relative overflow-hidden" data-id="element-422" data-mp="ixiwbvejubww">
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-423" data-mp="spf11pb550a3">
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-12 text-center uppercase" data-id="element-424" data-mp="sqzvzg1dal8h">
            ❓ Preguntas frecuentes
          </h2>
          <div className="space-y-4" data-id="element-425" data-mp="8kqi09vopma">
            {[{
            q: '¿Esto es para estudiantes?',
            a: 'No. Está pensado solo para noveles abogados en su primer año.'
          }, {
            q: '¿Es material digital?',
            a: 'Sí. Acceso y descarga inmediata.'
          }, {
            q: '¿Sirve en cualquier provincia?',
            a: 'Sí. Es válido para toda Argentina. (Y el bono del PJN aplica a los fueros principales.)'
          }, {
            q: '¿Necesito experiencia previa?',
            a: 'No. Es paso a paso, pensado para arrancar con estructura.'
          }, {
            q: '¿Esto reemplaza asesoramiento legal?',
            a: 'No. Es material educativo y de apoyo práctico. La estrategia jurídica siempre depende del caso.'
          }, {
            q: '¿Cómo recibo el material después de pagar?',
            a: 'Apenas confirmás la compra, recibís un email con los enlaces de descarga y el acceso al grupo de WhatsApp. Es inmediato.'
          }, {
            q: '¿Qué métodos de pago puedo usar?',
            a: 'Aceptamos todas las tarjetas de crédito y débito, además de Mercado Pago. Podés pagar hasta en 3 cuotas según tu tarjeta.'
          }, {
            q: '¿Tiene actualizaciones futuras incluidas?',
            a: 'Sí. Mientras tengamos acceso de por vida, recibís las actualizaciones de modelos y normativa que vayamos sumando, sin costo extra.'
          }, {
            q: '¿Hay soporte si tengo dudas con el material?',
            a: 'Sí. Podés escribirnos por mail y además tenés el grupo de WhatsApp con +714 colegas y nuestro equipo para destrabar cualquier duda.'
          }, {
            q: '¿Cómo funciona la garantía de 14 días?',
            a: 'Tenés 14 días desde la compra para probarlo. Si no te resulta útil, nos escribís y te devolvemos el 100% del dinero sin preguntas.'
          }].map((faq, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden border border-slate-200 shadow-[0_0_15px_rgba(0,0,0,0.03)] hover:shadow-[0_0_25px_rgba(234,179,8,0.15)] transition-shadow duration-300" data-id="element-426" data-mp="2e913fuuuywwc" data-mpi={index}>
                <button onClick={() => setOpenFaq(openFaq === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-slate-100 transition-colors" data-id="element-427" data-mp="ch684pswt50a">
                  <span className="text-lg font-bold text-slate-900" data-id="element-428" data-mp="ozi84ygnf7ds">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-6 w-6 text-slate-600 transition-transform ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-429" data-mp="ts1no0ywccl8" />
                </button>
                {openFaq === index && <div className="px-6 pb-6" data-id="element-430" data-mp="20ce6s7lcytj">
                    <p className="text-slate-700" data-id="element-431" data-mp="21ngsopaw0j2">{faq.a}</p>
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Cost of Inaction Section */}
      <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black text-white py-14 px-4 border-t border-slate-800 relative overflow-hidden" data-id="element-432" data-mp="ayo2uoowdmjc">
        <div className="absolute top-1/2 left-0 w-96 h-96 bg-red-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-433" data-mp="1mhidqrz1nhea"></div>
        <div className="absolute top-1/2 right-0 w-96 h-96 bg-yellow-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-434" data-mp="30bfk6csgdxur"></div>

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-435" data-mp="2vd4ac225rncj">
          <div className="text-center mb-12" data-id="element-436" data-mp="2vep59ssdx8ax">
            <h2 className="text-3xl md:text-5xl font-black uppercase text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 tracking-tight drop-shadow-[0_0_15px_rgba(234,179,8,0.2)]" data-id="element-437" data-mp="39d6phgj302o3">
              ⚖️ ¿Cuánto cuesta NO tenerlo?
            </h2>
            <p className="text-lg md:text-xl text-slate-300 mt-4 max-w-2xl mx-auto font-light" data-id="element-438" data-mp="3ebqclk9evki1">
              No comprarlo también tiene un precio. Y se paga en tiempo, plata y
              oportunidades perdidas.
            </p>
          </div>

          <div className="bg-slate-800/40 backdrop-blur-xl rounded-3xl border border-slate-700/50 shadow-2xl overflow-hidden" data-id="element-439" data-mp="3o1tfcc6c4ctk">
            {/* Table header */}
            <div className="grid grid-cols-2 bg-slate-900/80 border-b border-slate-700/50" data-id="element-440" data-mp="x3m3mz0505k">
              <div className="py-5 px-5 md:px-8 text-center border-r border-slate-700/50" data-id="element-441" data-mp="khuaiqdd26vc">
                <span className="text-sm md:text-lg font-black uppercase tracking-widest text-slate-300" data-id="element-442" data-mp="phqfosxso4ch">
                  Sin MegaPack
                </span>
              </div>
              <div className="py-5 px-5 md:px-8 text-center" data-id="element-443" data-mp="fj0vuumc89tl">
                <span className="text-sm md:text-lg font-black uppercase tracking-widest text-red-400" data-id="element-444" data-mp="fh6a5e38sdog">
                  Costo real
                </span>
              </div>
            </div>

            {[{
            without: 'Horas perdidas buscando modelos y formatos cada semana',
            cost: 'Semanas enteras de tu primer año tiradas a la basura'
          }, {
            without: 'Escritos rebotados por un formato mal armado',
            cost: 'Demoras, retrabajo y estrés que no para nunca'
          }, {
            without: 'Honorarios calculados "a ojo"',
            cost: 'Plata que dejás sobre la mesa en cada caso'
          }, {
            without: 'Trabas al subir escritos al portal del PJN',
            cost: 'Plazos en riesgo y clientes que se enojan'
          }, {
            without: 'Primera entrevista con clientes sin estructura',
            cost: 'Clientes que no vuelven ni te recomiendan'
          }, {
            without: 'Dudas que te frenan y nadie a quién preguntarle',
            cost: 'Avanzás lento y vivís corriendo atrás de todo'
          }, {
            without: 'Improvisar cada trámite desde cero',
            cost: 'El mismo caos el año que viene'
          }].map((row, i) => <div key={i} className={`grid grid-cols-2 border-b border-slate-700/40 ${i % 2 === 0 ? 'bg-slate-800/20' : 'bg-transparent'}`} data-id="element-445" data-mp="1yhp1tqj54yd8" data-mpi={i}>
                <div className="py-5 px-5 md:px-8 border-r border-slate-700/40 flex items-start gap-3" data-id="element-446" data-mp="1uf27niyzz1cv">
                  <XIcon className="h-5 w-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-447" data-mp="n3bimyzc173j" />
                  <span className="text-sm md:text-base text-slate-300 font-medium leading-relaxed" data-id="element-448" data-mp="j0ox1ft98ies">
                    {row.without}
                  </span>
                </div>
                <div className="py-5 px-5 md:px-8 flex items-start gap-3" data-id="element-449" data-mp="2ypm1jtr96cmp">
                  <span className="text-red-500 font-black flex-shrink-0 mt-0.5" data-id="element-450" data-mp="2ynj1si0at54s">
                    ↳
                  </span>
                  <span className="text-sm md:text-base text-red-300 font-semibold leading-relaxed" data-id="element-451" data-mp="38g8cvbrxsgzl">
                    {row.cost}
                  </span>
                </div>
              </div>)}
          </div>

          <div className="mt-10 text-center" data-id="element-452" data-mp="3id38nmwts3a6">
            <p className="inline-block bg-yellow-500/10 border border-yellow-500/30 text-yellow-300 px-8 py-4 rounded-2xl text-lg md:text-xl font-bold shadow-[0_0_20px_rgba(234,179,8,0.1)]" data-id="element-453" data-mp="3ifz67a4rgpy3">
              El MegaPack cuesta menos que una sola semana perdida improvisando.
            </p>
          </div>

          <div className="flex justify-center mt-8" data-id="element-454" data-mp="1s3jfjxasvt1v">
            <a href="#compra" onClick={scrollToOffer} className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-lg md:text-2xl px-12 py-6 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.3)] hover:shadow-[0_0_50px_rgba(34,197,94,0.5)] transform hover:scale-105 transition-all duration-300 uppercase text-center border-2 border-green-400" data-id="element-455" data-mp="1x1kz0jc51udv">
              QUIERO DEJAR DE PERDER TIEMPO
            </a>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="w-full bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black text-white py-14 px-4 border-t border-slate-800 relative overflow-hidden" data-id="element-456" data-mp="3fzzg5uzmuhte">
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-96 bg-yellow-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-457" data-mp="3pyymv80u83dr"></div>
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,1) 1px, transparent 1px)',
        backgroundSize: '64px 64px'
      }} data-id="element-458" data-mp="156n20zsw6a4y"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-459" data-mp="2n4ruub5adugh">
          <h2 className="text-4xl md:text-6xl font-black mb-8 uppercase text-center text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 tracking-tight drop-shadow-[0_0_15px_rgba(234,179,8,0.2)]" data-id="element-460" data-mp="2n62xg7mzww60">
            Tu primer año no tiene por qué ser "modo caos".
          </h2>
          <div className="bg-slate-800/50 backdrop-blur-md border border-slate-700/50 rounded-3xl p-8 md:p-12 mb-12 shadow-2xl" data-id="element-461" data-mp="31vscn6rxb0pa">
            <p className="text-xl md:text-3xl mb-4 text-center text-slate-300 font-light" data-id="element-462" data-mp="2s44ekn0v2leu">
              No necesitás más PDFs sueltos.
            </p>
            <p className="text-xl md:text-3xl text-center text-white font-medium" data-id="element-463" data-mp="2x1ebenqkxzcp">
              Necesitás un sistema para ejercer con{' '}
              <span className="text-yellow-400 font-bold" data-id="element-464" data-mp="3pj06msjwinc0">
                seguridad y velocidad
              </span>{' '}
              desde ya.
            </p>
          </div>
          {/* ÚLTIMO BOTÓN → CHECKOUT DIRECTO */}
          <a href="https://megapacknovelesabogados.impultienda.ar/" className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-2xl md:text-4xl px-16 py-8 rounded-2xl shadow-[0_0_40px_rgba(34,197,94,0.4)] hover:shadow-[0_0_60px_rgba(34,197,94,0.6)] transform hover:scale-105 transition-all duration-300 animate-pulse-slow uppercase text-center border-2 border-green-400" data-id="element-465" data-mp="10c6kcazzsin8">
            QUIERO MI MEGAPACK
          </a>
        </div>
      </section>
    </div>;
}